import { Charts } from './Charts';
import ParentsInfoChartsDataProvider from './contexts/ParentsInfoChartsDataContext';

const ParentsInfoWrapper = () => {
    return (
        <ParentsInfoChartsDataProvider>
            <Charts />
        </ParentsInfoChartsDataProvider>
    );
};

export default ParentsInfoWrapper;
